import { useContext } from "react";
import SettingsContext from "../context/settingsContext";

const useSettingsContext = () => {
  return useContext(SettingsContext);
};

export default useSettingsContext;
